import get from 'lodash/get';
import includes from 'lodash/includes';
import toLower from 'lodash/toLower';

import { availableNamedLanguages } from '@savgroup-front-common/constants';
import { changeLocaleLanguage } from '@savgroup-front-common/core/domains/i18n/actions';
import { getSellers } from '@savgroup-front-common/core/domains/sellers/actionCreators';
import { defaultLanguage } from '@savgroup-front-common/core/helpers';

import { AuthorizationService } from '@/api';

const loginSignedIn =
  ({ payload, setLoginStore }) =>
  (dispatch) => {
    const preferedLanguage =
      toLower(get(payload, 'preferences.language')) ||
      toLower(navigator.language).slice(0, 2);
    const chosenLanguage = includes(availableNamedLanguages, preferedLanguage)
      ? preferedLanguage
      : defaultLanguage;

    if (chosenLanguage) {
      dispatch(changeLocaleLanguage({ locale: chosenLanguage }));
    }
    setLoginStore(payload);
  };

export const signIn =
  ({ onLogin, onGetUserForbidden, setLoginStore } = {}) =>
  async (dispatch) => {
    try {
      const result = await AuthorizationService.getUser();

      if (onLogin) {
        onLogin();
      }

      const payload = {
        isLoaded: true,
        ...result.value,
        failure: result.failure,
        errors: result.errors,
      };

      dispatch(getSellers({}));
      dispatch(loginSignedIn({ payload, setLoginStore }));
    } catch (errors) {
      if (
        errors.errors?.some(
          (error) =>
            error.code === 'Reverse.Common.Errors.Authentication.Forbidden',
        ) &&
        onGetUserForbidden
      ) {
        onGetUserForbidden();

        return;
      }
      const payload = {
        isLoaded: true,
        failure: true,
        errors,
      };

      dispatch(loginSignedIn({ payload, setLoginStore }));
    }
  };
